import { render, staticRenderFns } from "./BmvFileUpload.vue?vue&type=template&id=81ddcce8&scoped=true"
import script from "./BmvFileUpload.vue?vue&type=script&lang=js"
export * from "./BmvFileUpload.vue?vue&type=script&lang=js"
import style0 from "./BmvFileUpload.vue?vue&type=style&index=0&id=81ddcce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ddcce8",
  null
  
)

export default component.exports